module.exports = __webpack_public_path__ + "static/img/头图.9dd6faff.png";